module.exports = __webpack_public_path__ + "static/lung-30fe89d20ce51467b6be1e4d88d9dc5c.jpg";